"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = exports.BigNumbers = void 0;
Object.defineProperty(exports, "BodyStatus", {
  enumerable: true,
  get: function get() {
    return _internalTypography.BodyStatus;
  }
});
exports.TertiaryBody = exports.SectionTitle = exports.SectionHeader = exports.SecondaryBody = exports.Paragraph = exports.MainHeader = exports.Link = exports.Label = exports.ExternalLink = exports.DangerLink = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireDefault(require("./theme"));
var _internalTypography = require("../internal/internal-typography");
var _constants = require("../utils/constants");
var _FormLabel = _interopRequireDefault(require("@mui/material/FormLabel"));
var _material_ui_theme = require("../components/forms/text_input/material_ui_theme");
var _excluded = ["className", "children", "dangerouslySetInnerHTML", "strikethrough"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MainHeader = exports.MainHeader = _styledComponents["default"].h1.withConfig({
  displayName: "typography__MainHeader"
})(["font-family:", ";font-weight:", ";font-size:2.375rem;line-height:2.625rem;color:", ";", " ", ""], _theme["default"].fonts.serif, _theme["default"].fontWeights.normal, _theme["default"].colors.primary, _internalTypography.spacingReset, _internalTypography.inlineIcon);
MainHeader.displayName = 'MainHeader';
var SectionHeaderStyledComponent = _styledComponents["default"].h2.withConfig({
  displayName: "typography__SectionHeaderStyledComponent"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";", " ", ""], _theme["default"].fonts.sans, _theme["default"].fontWeights.normal, function (_ref) {
  var large = _ref.large;
  return !large ? "1.5rem" : "1.75rem";
}, function (_ref2) {
  var large = _ref2.large;
  return !large ? "2rem" : "2.5rem";
}, _theme["default"].colors.primary, _internalTypography.spacingReset, _internalTypography.inlineIcon);
SectionHeaderStyledComponent.displayName = 'SectionHeaderStyledComponent';
var SectionHeader = exports.SectionHeader = function SectionHeader(props) {
  var as = props.as,
    children = props.children,
    large = props.large;
  return /*#__PURE__*/React.createElement(SectionHeaderStyledComponent, (0, _extends2["default"])({
    as: as,
    large: large
  }, (0, _constants.getDataProvidesProps)(props)), children);
};
SectionHeader.displayName = 'SectionHeader';
var SectionTitleStyledComponent = _styledComponents["default"].h3.withConfig({
  displayName: "typography__SectionTitleStyledComponent"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:1.5rem;color:", ";", " ", ""], _theme["default"].fonts.sans, _theme["default"].fontWeights.medium, function (_ref3) {
  var large = _ref3.large;
  return !large ? "1.125rem" : "1.25rem";
}, _theme["default"].colors.primary, _internalTypography.spacingReset, _internalTypography.inlineIcon);
SectionTitleStyledComponent.displayName = 'SectionTitleStyledComponent';
var SectionTitle = exports.SectionTitle = function SectionTitle(props) {
  var as = props.as,
    children = props.children,
    large = props.large;
  return /*#__PURE__*/React.createElement(SectionTitleStyledComponent, (0, _extends2["default"])({
    as: as,
    large: large
  }, (0, _constants.getDataProvidesProps)(props)), children);
};
SectionTitle.displayName = 'SectionTitle';
var BigNumbers = exports.BigNumbers = _styledComponents["default"].span.withConfig({
  displayName: "typography__BigNumbers"
})(["font-family:", ";font-weight:", ";font-size:2rem;line-height:2.5rem;color:", ";", " ", ""], _theme["default"].fonts.serif, _theme["default"].fontWeights.normal, _theme["default"].colors.primary, _internalTypography.spacingReset, _internalTypography.inlineIcon);
BigNumbers.displayName = 'BigNumbers';
var Paragraph = exports.Paragraph = function Paragraph(props) {
  var className = props.className,
    children = props.children,
    dangerouslySetInnerHTML = props.dangerouslySetInnerHTML,
    strikethrough = props.strikethrough,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (dangerouslySetInnerHTML) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/forbid-elements
      React.createElement("p", (0, _extends2["default"])({}, rest, {
        className: className,
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
      }))
    );
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    React.createElement("p", (0, _extends2["default"])({}, rest, {
      className: className
    }), children, strikethrough && /*#__PURE__*/React.createElement(VisuallyHiddenSpan, null, "(struck through)"))
  );
};
var Body = exports.Body = (0, _styledComponents["default"])(Paragraph).withConfig({
  displayName: "typography__Body"
})(["", ""], _internalTypography.bodyStyles);
Body.displayName = 'Body';
var VisuallyHiddenSpan = _styledComponents["default"].span.withConfig({
  displayName: "typography__VisuallyHiddenSpan"
})(["position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);clip-path:inset(50%);white-space:nowrap;border:0;margin:-1px;padding:0;"]);
var SecondaryBody = exports.SecondaryBody = (0, _styledComponents["default"])(Paragraph).withConfig({
  displayName: "typography__SecondaryBody"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";", " ", " ", ""], _theme["default"].fonts.sans, function (_ref4) {
  var medium = _ref4.medium;
  return medium ? _theme["default"].fontWeights.medium : _theme["default"].fontWeights.normal;
}, function (props) {
  return props.theme.fontSmallSize;
}, function (props) {
  return props.theme.fontSmallLineHeight;
}, function (_ref5) {
  var metadata = _ref5.metadata;
  return metadata ? _theme["default"].colors.metadata : _theme["default"].colors.primary;
}, _internalTypography.spacingReset, _internalTypography.inlineIcon, _internalTypography.strikethrough);
SecondaryBody.displayName = 'SecondaryBody';
var TertiaryBody = exports.TertiaryBody = (0, _styledComponents["default"])(Paragraph).withConfig({
  displayName: "typography__TertiaryBody"
})(["font-family:", ";font-weight:", ";font-size:0.875rem;line-height:1.25rem;color:", ";", " ", " ", ""], _theme["default"].fonts.sans, _theme["default"].fontWeights.normal, _theme["default"].colors.tertiary, _internalTypography.spacingReset, _internalTypography.inlineIcon, _internalTypography.strikethrough);
TertiaryBody.displayName = 'TertiaryBody';
var Link = exports.Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(_internalTypography.StyledAnchorTag, (0, _extends2["default"])({}, props, {
    ref: ref
  }), props.children);
});
Link.displayName = 'Link';
var DangerLink = exports.DangerLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(_internalTypography.StyledAnchorTag, (0, _extends2["default"])({}, props, {
    ref: ref,
    danger: true
  }), props.children);
});
DangerLink.displayName = 'DangerLink';
var ExternalLink = exports.ExternalLink = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(_internalTypography.StyledAnchorTag, (0, _extends2["default"])({
    target: "_blank",
    rel: "noopener noreferrer"
  }, props, {
    ref: ref
  }), props.children);
});
ExternalLink.displayName = 'ExternalLink';
var StyledFormLabel = (0, _styledComponents["default"])(_FormLabel["default"]).withConfig({
  displayName: "typography__StyledFormLabel"
})(["", ""], _material_ui_theme.baseInputLabelCSS);
var Label = exports.Label = function Label(props) {
  return /*#__PURE__*/React.createElement(StyledFormLabel, (0, _extends2["default"])({}, props, {
    $standaloneLabel: true
  }));
};